/**
 * Purchase hint resolution (docs/finished/ingredient-catalog-spec.md 6.8).
 * Most specific first: product + store, product, ingredient + store, ingredient.
 * A hint for a chain applies in all its branches; a hint for a branch applies there only.
 */
function specificity(hint) {
    if (hint.productId)
        return hint.storeId ? 4 : 3;
    return hint.storeId ? 2 : 1;
}
function appliesInStore(hint, target) {
    if (!hint.storeId)
        return true;
    if (!target.storeId)
        return false;
    return hint.storeId === target.storeId || hint.storeId === (target.storeParentId ?? null);
}
export function resolveHints(hints, target) {
    const relevant = hints.filter((h) => (!!target.productId && h.productId === target.productId) ||
        (!!target.ingredientId && h.ingredientId === target.ingredientId));
    const byRank = (a, b) => specificity(b) - specificity(a) || b.updatedAt.localeCompare(a.updatedAt);
    const applicable = relevant.filter((h) => appliesInStore(h, target)).sort(byRank);
    const elsewhere = relevant.filter((h) => !appliesInStore(h, target)).sort(byRank);
    // The marker follows the most specific level that carries a verdict; within that level
    // the newest hint wins. Notes alone never produce a warning.
    let marker = applicable.length ? 'NOTE' : 'NONE';
    const decisive = applicable.find((h) => h.verdict !== 'NOTE');
    if (decisive)
        marker = decisive.verdict;
    return { applicable, elsewhere, marker };
}
export function summarizeHints(hints) {
    const ratings = hints.map((h) => h.rating).filter((r) => typeof r === 'number');
    return {
        recommended: hints.filter((h) => h.verdict === 'RECOMMENDED').length,
        avoid: hints.filter((h) => h.verdict === 'AVOID').length,
        note: hints.filter((h) => h.verdict === 'NOTE').length,
        averageRating: ratings.length
            ? Math.round((ratings.reduce((a, b) => a + b, 0) / ratings.length) * 10) / 10
            : null,
    };
}
//# sourceMappingURL=hints.js.map